module.exports = __webpack_public_path__ + "img/wallet_pc_06.b260a51d.png";